import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import PageTitle from '../../Components/PageTitle';
import { images } from '../../assets/images';
import { routes } from '../../routes';
import { Animated } from 'react-animated-css';

import { TechnologiesSlider } from '../Home/technologies';
import { TestimonialSlider } from '../Home/testimonials';
import ContentController from '../../apis/controller/content.controller';
import { renderImage } from '../../Components/helper/image';

function Parthership() {
    const [partnerUs, setPartnerUs] = useState();
    const [breadCrumbs, setBreadcrumbs] = useState();
    const [loader, setLoader] = useState(false);

    useEffect(() => {
        getPartners();
        window.scrollTo(0, 0);
    }, []);

    const getPartners = async () => {
        setLoader(true);
        let res = await new ContentController().partnership();
        if (res && res.status) {
            setPartnerUs(res.page);
            setBreadcrumbs(res.breadcrumb);
        }
        setLoader(false);
    };
    return (
        <>
            {breadCrumbs ? <PageTitle title={breadCrumbs.main_title} image={breadCrumbs.image} /> : null}
            {partnerUs && <div className='parthership-wrap'>
                <div className='container'>
                    <div className='row'>
                        <div className='col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12'>
                            <div className='content_parther'>
                                <div className='row align-items-center'>
                                    <div className='col-xxl-6 col-xl-6 col-lg-6 col-md-12 col-sm-12 col-12'>
                                        <div className='left_in'>
                                            <p>
                                                {partnerUs.title}
                                            </p>
                                            <p>
                                                {partnerUs.description}
                                            </p>
                                        </div>
                                    </div>
                                    <div className='col-xxl-6 col-xl-6 col-lg-6 col-md-12 col-sm-12 col-12'>
                                        <div className="img_area">
                                            <img src={images.parthership} alt=".." />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className='col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12'>
                            <div className="benefits_wrap">
                                <div className="benefits_wrap_set">
                                    <div className="benefits_wrap_head">
                                        <h2>Benefits Of Partnering</h2>
                                    </div>
                                    {partnerUs.benefits_of_partnering.length> 0 && <div className="row">
                                    {partnerUs.benefits_of_partnering.map((item, index) => (
                                        <div key={index} className="col-xxl-6 col-xl-6 col-lg-6 col-md-6 col-sm-6 col-12">
                                            <div className="advantage_item ">
                                                <div className="d-flex">
                                                    <div className="icon_area">
                                                        <img src={renderImage(item.image)} className="img-fluid" alt="..." />
                                                    </div>
                                                    <div className="content_area">
                                                        <h5>{item.title}</h5>
                                                        <p>{item.description}</p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    ))}
                                    </div>}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>}
            <section className="technologies_section el pt-5">
                {<div className="container">
                    <div className="row">
                        <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
                            <div className="technologies_area">
                                <div className="section_title both_line text-center txt_white">
                                    <h2>As Featured In</h2>
                                </div>
                                <TechnologiesSlider />
                            </div>
                        </div>
                    </div>
                </div>}
            </section>
            <section className="testimonials_section el pt-5 pb-5" style={{ backgroundImage: `url(${images.process2})` }}>
                <div className="testimonials_area">
                    <div className="container">
                        <div className="row">
                            <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
                                <div className="section_title both_line text-center">
                                    <h2>Testimonials</h2>
                                </div>
                                <div className="row justify-content-center">
                                    <div className="col-xl-9 col-lg-10 col-md-11 col-sm-12 col-12">
                                        <TestimonialSlider />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <div className='grow_business_set'>
                <div className='container'>
                    <div className='row'>
                        <div className='col-xxl-12 col-12 col-lg-12 col-sm-12 col-12'>
                            <div className='grow_business'>
                                <div className="left">
                                    <h3>
                                        Become Partner With Us
                                    </h3>
                                    <p>
                                        Expand your Service Offerings and Multiply Your Profits
                                    </p>
                                </div>
                                <div className="right">
                                    <Link to="" className="btn-primary_set">CONTACT US<i className="fal fa-angle-double-right ps-2"></i></Link>
                                    <Link to="" className="btn-primary_set">APPLY NOW<i className="fal fa-angle-double-right ps-2"></i></Link>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default Parthership;